import { Form as FormSource, Props as PropsSource } from '../Form'
import { NetworkGuardWrap } from 'shared/ui/common/NetworkGuardWrap'

type Props<TFieldValues> = PropsSource<TFieldValues>

export function Form<TFieldValues>(formProps: Props<TFieldValues>) {
  return (
    <NetworkGuardWrap>
      <FormSource {...formProps} />
    </NetworkGuardWrap>
  )
}
